// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--q2xeb";
export var Close = "styles-module--Close--pZSf-";
export var Success = "styles-module--Success--fgrra";
export var ctas = "styles-module--ctas--Di9XO";
export var spacer = "styles-module--spacer--6d0j8";